'use client';

import { cn } from '@repo/utils/cn';
import Image, { type StaticImageData } from 'next/image';
import React, { type ReactNode } from 'react';
import { UnStyledLink } from '@/components/common/link';

type CategoryProps = {
  title: string;
  Icon: ReactNode;
  img: StaticImageData;
  href: string;
  contentClassName?: string;
  imgClassName?: string;
  borderGradientClass?: string;
  bgGradientClass?: string;
  className?: string;
};

const Category = ({
  title,
  Icon,
  img,
  href,
  imgClassName,
  contentClassName,
  borderGradientClass,
  bgGradientClass,
  className,
}: CategoryProps) => {
  return (
    <div className={cn('group rounded-xl p-[1px]', borderGradientClass, className)}>
      <UnStyledLink
        href={href}
        className={cn(
          'relative flex h-full w-full flex-row items-center justify-center overflow-hidden rounded-xl pl-5 sm:flex-col sm:p-0 sm:pt-5 rtl:pr-5',
          bgGradientClass
        )}
      >
        <div
          className={cn('flex w-1/2 flex-col items-start justify-center sm:h-1/2 sm:items-center', contentClassName)}
        >
          <div className="flex items-center justify-start space-x-2 rtl:space-x-reverse">
            <div className="transform-gpu transition-transform duration-200 ease-out group-hover:rotate-6">{Icon}</div>
            <span className="truncate text-[16px] font-bold transition-colors duration-200 ease-out vt-font-highlight-font-family vt-utility-white group-hover:text-yellow-300 md:text-2xl">
              {title}
            </span>
          </div>
        </div>
        <div className="flex w-1/2 items-center justify-center overflow-hidden sm:mt-4 sm:h-1/2 sm:w-full">
          <Image
            priority
            width={0}
            height={0}
            quality={100}
            src={img}
            alt={title}
            className={cn(
              'max-h-[80px] w-auto transform-gpu object-contain transition-transform duration-200 ease-out group-hover:scale-110 sm:h-[210px] sm:max-h-none',
              imgClassName
            )}
          />
        </div>
      </UnStyledLink>
    </div>
  );
};

export default Category;
